/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { Flex, Tooltip } from '@chakra-ui/react'
import { voidEvent } from '@zcode/nr-utils'
import { hyphenate } from '@zcode/utils'
import React from 'react'
import type { badgeTitlesAndLabelsMap } from './constants'

export interface ListCardBadgeProps {
  label: (typeof badgeTitlesAndLabelsMap)[keyof typeof badgeTitlesAndLabelsMap][1]
  title: (typeof badgeTitlesAndLabelsMap)[keyof typeof badgeTitlesAndLabelsMap][0]
}

export const ListCardBadge = ({ label, title }: ListCardBadgeProps) => {
  const id = `property-badges-${hyphenate(title.toLowerCase())}`

  return (
    <Tooltip
      gutter={12}
      border="1px solid var(--chakra-colors-gray-150)"
      borderRadius="lg"
      background="gray.0"
      color="gray.600"
      hasArrow
      id={id}
      label={label}
      py={3}
      px={4}
      fontSize="xs"
      lineHeight={5}
      maxW="280px"
      placement="bottom"
      sx={{
        '.chakra-tooltip__arrow-wrapper .chakra-tooltip__arrow': {
          borderLeft: '1px solid var(--chakra-colors-gray-150)',
          borderTop: '1px solid var(--chakra-colors-gray-150)',
          top: '-1px !important',
        },
      }}
    >
      <Flex
        data-testid="list-card-badge"
        onClick={(e) => {
          voidEvent(e)
        }}
        width="max-content"
        height="22px"
        margin="0 4px 0 0"
        padding="4px 12px"
        color="gray.800"
        fontWeight="normal"
        fontSize="sm"
        lineHeight="9px"
        letterSpacing="0.3px"
        background="gray.0"
        borderRadius="base"
        gap={1}
        alignItems="center"
      >
        {title}
      </Flex>
    </Tooltip>
  )
}
